import { Mail, Phone, MapPin, Send, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { fetchData } from "@/lib/supabase-function";
import { SendMessage } from "@/pages/api/send-quote";

export function ContactForm() {
const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    countrycode: "",
    mobileNumber: "",
    companyName: "",
    requirementDetails: "",
    serviceCombo: "",
    customService: ""
  });  
const [countrycode, setCountryCode] = useState("+91");
const [isSubmitting, setIsSubmitting] = useState(false);
const [showCustomService, setShowCustomService] = useState(false);
const { toast } = useToast();
const [services, setServices] = useState([]);
  useEffect(() => {
    const load = async () => {
      const data = await fetchData(
        "services",
        "title, srno",
        "srno",
        "is_active",
        true,
        false,
        null    
      );  
       if (data && data.length > 0) {
      setServices(data);
    }  
    };
  
    load();
  }, []);  
useEffect(() => {   
      fetch("https://ipapi.co/json/")
        .then((res) => res.json())
        .then((data) => {
          setCountryCode(data.country_calling_code || "+91");
          setFormData((prev) => ({ ...prev, countrycode: data.country_calling_code || "+91" }));
        })
        .catch((err) => {
          console.error("Error fetching country code:", err);
          setCountryCode("+91");
          setFormData((prev) => ({ ...prev, countrycode: "+91" }));
        });    
  },[]);
  const cleanCode = (formData.countrycode || "").replace("+", "");
  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleServiceChange = (value: string) => {
    setFormData((prev) => ({ ...prev, serviceCombo: value }));
    setShowCustomService(value === "Other");
    if (value !== "Other") {
      setFormData((prev) => ({ ...prev, customService: "" }));
    }
  };
   const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setIsSubmitting(true);
  
      try {
        const { error } = await supabase
          .from("quotes")
          .insert([
            {
              full_name: formData.fullName,
              email: formData.email,            
              mobile_number: cleanCode+formData.mobileNumber,
              company_name: formData.companyName,
              requirement_details: formData.requirementDetails,
              service_combo: formData.serviceCombo,
              custom_service: formData.customService
            }
          ]);
  
        if (error) throw error;
  
      const requestData = {
          name: formData.fullName,         
          mobile: cleanCode+formData.mobileNumber,
          company: formData.companyName,
          requirement: formData.requirementDetails,
          service: formData.serviceCombo      
      };
  
        //const message = `*New Quotation Request*\n\n*Name:* ${formData.fullName}\n*Email:* ${formData.email}\n*Mobile:* ${cleanCode}${formData.mobileNumber}\n*Company:* ${formData.companyName}\n*Requirement:* ${formData.requirementDetails}\n*Service:* ${formData.serviceCombo}\n*Custom Service:* ${formData.customService || "N/A"}`;
  
      const jsonData = JSON.stringify(formData, null, 2);
      SendMessage(jsonData);
  
        toast({
          title: "Thank you!",
          description: "Thank you, our team will contact you soon!"
        });
  
        // Reset form
        setFormData({
          fullName: "",
          email: "",
          countrycode: countrycode, // keep detected country code
          mobileNumber: "",
          companyName: "",
          requirementDetails: "",
          serviceCombo: "",
          customService: ""
        });
        setShowCustomService(false);      
      } catch (error) {
        console.error("Error submitting quote:", error);
        toast({
          title: "Error",
          description: "Failed to submit quote request. Please try again.",
          variant: "destructive"
        });
      } finally {
        setIsSubmitting(false);
      }
    };
  return ( 
      <form onSubmit={handleSubmit} className="space-y-2">                
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Name</label>
          <Input
                id="fullName"
                value={formData.fullName}
                onChange={(e) => handleInputChange("fullName", e.target.value)}
                required
                placeholder="Enter your full name"
              />
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Email</label>
          <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  required
                  placeholder="Enter your email"
                />
        </div>
          <div className="space-y-2">
                <Label htmlFor="companyName">Company Name</Label>
                <Input
                  id="companyName"
                  value={formData.companyName}
                  onChange={(e) => handleInputChange("companyName", e.target.value)}
                  placeholder="Enter your company name"
                />
              </div>                                       
      
            <div className="flex space-x-1">
                <Label htmlFor="countrycode" className="sr-only">
                  Country Code
                </Label>
                <Input
                  id="countrycode"
                  name="countrycode"
                  value={countrycode}
                  readOnly
                  className="w-16 text-center bg-gray-100 text-gray-700"
                />
                <Input
                  id="mobileNumber"
                  name="mobileNumber"
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.mobileNumber}
                  onChange={(e) => handleInputChange("mobileNumber", e.target.value)}
                  required
                  placeholder="Enter your mobile number"
                  autoComplete="tel-national"
                />
              </div>

                <div className="space-y-2">
                  <Label htmlFor="serviceCombo">Service Required *</Label>
                  <Select
                    value={formData.serviceCombo}
                    onValueChange={handleServiceChange}
                    required
                  >
                    <SelectTrigger
                      id="serviceCombo"
                      aria-label="Select a service required"
                      aria-labelledby="serviceComboLabel"
                    >
                      <SelectValue placeholder="Select a service" />
                    </SelectTrigger>
                    <SelectContent>
                      {services.map((service) => (
                        <SelectItem key={service.srno} value={service.title}>
                          {service.title}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

    
              {showCustomService && (
                <div className="space-y-2">
                  <Label htmlFor="customService">Please specify your custom service *</Label>
                  <Input
                    id="customService"
                    value={formData.customService}
                    onChange={(e) => handleInputChange("customService", e.target.value)}
                    required={showCustomService}
                    placeholder="Describe your custom service requirement"
                  />
                </div>
              )}
    
              <div className="space-y-2">
                <Label htmlFor="requirementDetails">Requirement Details</Label>
                <Textarea
                  id="requirementDetails"
                  value={formData.requirementDetails}
                  onChange={(e) => handleInputChange("requirementDetails", e.target.value)}
                  placeholder="Describe your project requirements in detail"
                  rows={3}
                />
              </div>           
              <Button type="submit" disabled={isSubmitting} className="btn-hero w-full group">
                  {isSubmitting ? "Submitting..." : "Send message"}
                  <Send className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>   
        </form>              
  );
}